// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const trackerApi = {
  getTrackers(campaignId) {
    return client.get(`/tracker/trackers?campaignId=${campaignId}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getSelfServiceContentTrackers(campaignId, creativeId) {
    return client.get(`/tracker/campaigns/${campaignId}/trackers?creativeId=${creativeId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getTrackersCSV(campaignId) {
    return client.get(`/tracker/trackers/csv?campaignId=${campaignId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  persistTrackers(campaignId, trackers, fileUploadUuid) {
    let queryParams = `?campaignId=${campaignId}`;
    queryParams += fileUploadUuid ? `&fileUploadUuid=${fileUploadUuid}` : '';
    return client.post(`/tracker/trackers${queryParams}`, trackers)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  persistTrackersManually(campaignId, trackers) {
    return client.post(`/tracker/campaigns/${campaignId}/trackers/manual`, trackers)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  updateATrackerValue(campaignId, trackerId, newVal) {
    return client.patch(`/tracker/campaigns/${campaignId}/trackers/${trackerId}`, newVal)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  saveSelfServiceContentTrackers(payload) {
    return client.post('/tracker/trackers', { ...payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  async getTrackersValidations(campaignId) {
    return client.get(`/tracker/trackers/validations?campaignId=${campaignId}`).then((response) => response.data);
  },
  async putTrackersRevalidations(campaignId) {
    return client.put(`/tracker/tracker-validations/campaigns/${campaignId}`);
  },
  parseTrackersFile({ file, campaignId }, loadingConfig) {
    const formData = new FormData();
    formData.append('file', file);

    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
      ...loadingConfig,
    };

    return client.post(`/tracker/trackers/parse?campaignId=${campaignId}`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteTrackers(campaignId, trackerIds) {
    return client.delete(`/tracker/campaigns/${campaignId}/trackers?ids=${trackerIds.join(',')}`)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  },
  deleteTrackersValidations(campaignId, fileUploadUuid) {
    return client.delete(`/tracker/trackers/validations?campaignId=${campaignId}&fileUploadUuid=${fileUploadUuid}`)
      .then((response) => response);
  },
};
export default trackerApi;
